var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"pagename"},[_c('transition',{attrs:{"name":"fadein","mode":"out-in"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }